export default __webpack_public_path__ + "media/images/flutter_logo-2d079625.svg";